export default "__VITE_ASSET__DA2YQC3A__"